import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import ScrollToTop from "./components/alva/ScrollToTop";
import CookieBanner from "./components/alva/CookieBanner";

// Code-splitting : chaque route est chargée à la volée.
// La home reste prioritaire (pas de lazy) pour ne pas pénaliser le LCP.
import Home from "./pages/Home";

const Expertises               = lazy(() => import("./pages/Expertises"));
const CreationSiteWeb          = lazy(() => import("./pages/CreationSiteWeb"));
const ReferencementLocalSEO    = lazy(() => import("./pages/ReferencementLocalSEO"));
const IdentiteVisuelle         = lazy(() => import("./pages/IdentiteVisuelle"));
const SitePlombier             = lazy(() => import("./pages/SitePlombier"));
const SiteCouvreur             = lazy(() => import("./pages/SiteCouvreur"));
const SiteElectricien          = lazy(() => import("./pages/SiteElectricien"));
const MethodePage              = lazy(() => import("./pages/MethodePage"));
const TarifsPage               = lazy(() => import("./pages/TarifsPage"));
const AgencePage               = lazy(() => import("./pages/AgencePage"));
const AuditGratuitPage         = lazy(() => import("./pages/AuditGratuitPage"));
const BlogSoon                 = lazy(() => import("./pages/BlogSoon"));
const Legal                    = lazy(() => import("./pages/Legal"));
const CGV                      = lazy(() => import("./pages/CGV"));
const PolitiqueConfidentialite = lazy(() => import("./pages/PolitiqueConfidentialite"));

// Fallback minimaliste — gardé léger pour ne pas surcharger.
function RouteFallback() {
    return (
        <div
            className="min-h-screen flex items-center justify-center bg-[#F7F7F5]"
            aria-busy="true"
            aria-live="polite"
            data-testid="route-fallback"
        >
            <span className="size-8 rounded-full border-2 border-[#1A2F6E]/15 border-t-[#2B7BE4] animate-spin" />
        </div>
    );
}

function App() {
    return (
        <HelmetProvider>
            <div className="App">
                <BrowserRouter>
                    <ScrollToTop />
                    <Suspense fallback={<RouteFallback />}>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/expertises" element={<Expertises />} />
                            <Route path="/creation-site-web" element={<CreationSiteWeb />} />
                            <Route path="/referencement-local-seo" element={<ReferencementLocalSEO />} />
                            <Route path="/identite-visuelle" element={<IdentiteVisuelle />} />
                            <Route path="/site-web-plombier" element={<SitePlombier />} />
                            <Route path="/site-web-couvreur-rge" element={<SiteCouvreur />} />
                            <Route path="/site-web-electricien" element={<SiteElectricien />} />
                            <Route path="/methode" element={<MethodePage />} />
                            <Route path="/tarifs" element={<TarifsPage />} />
                            <Route path="/agence" element={<AgencePage />} />
                            <Route path="/audit-gratuit" element={<AuditGratuitPage />} />
                            <Route path="/blog" element={<BlogSoon />} />
                            <Route path="/mentions-legales" element={<Legal />} />
                            <Route path="/cgv" element={<CGV />} />
                            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
                        </Routes>
                    </Suspense>
                    <CookieBanner />
                </BrowserRouter>
                <Toaster position="top-right" richColors />
            </div>
        </HelmetProvider>
    );
}

export default App;
